export const es = {
  links: {
    home: "Página de inicio",
    mission: "Misión",
    services: "Servicios",
    contact: "Contacto",
    privacy: "Política de privacidad",
    paymentPlans: "Planes de Pago",
  },
  contact: {
    title: "Información de contacto",
    findUs: "Encuéntranos",
    btnWhatsapp: "btn_whatsapp_es.png",
    Call: "Llama al 754.752.1888",
    SMS: "Mensaje de texto 754.752.1888",
    WhatsappMsg: "WhatsApp 754.276.1746",
    AfterHours:
      "TENGA EN CUENTA: DESPUÉS DE HORAS Y FINES DE SEMANA - Solo estamos disponibles a través de mensajes de texto en:",
  },
  img: {
    img1: "1_es2.jpg",
    img2: "2_es2.jpg",
  },
  footer: {
    quickLinks: "Enlaces rápidos",
    bookAppointment: "Reservar una cita",
  },
  altsImgs: {
    btnWhatsapp: "Botón para iniciar chat de WhatsApp.",
    logoDiverse: "Diverse Care Now",
    slide1: "Diapositiva 1",
    slide2: "Diapositiva 2",
  },
  carousel: {
    previous: "Anterior",
    next: "Siguiente",
  },
  modal: {
    title: "Reservar una cita",
    message: "Reserve una cita ahora",
    close: "Cerrar",
    bookNow: "Reservar ahora",
  },
};
